import {z} from 'zod';

export const LeasingCellSchema = z.object({
  termMonths: z.number(),
  annualMileage: z.number(),
});
export type LeasingCell = z.infer<typeof LeasingCellSchema>;
